'use client';

import { useMemo, useState, useCallback } from 'react';
import dynamic from 'next/dynamic';

//* Components
import Page from '@components/global/Page';
import Faq from '@components/pages/Services/Faq';
import TableItem from '@components/global/TableItem';
import Testimonials from '@components/global/Testimonials';
import AnimationWrap from '@components/global/AnimationWrap';
import HTMLContainer from '@components/global/HTMLContainer';
import WhyChoose from '@components/pages/Services/WhyChoose';
import PageTopSection from '@components/global/PageTopSection';
import SubServices from '@components/pages/Services/SubServices';
import WorkProcess from '@components/pages/Services/WorkProcess';
const PortfolioShortList = dynamic(() => import('@/components/global/PortfolioShortList'));

//* Styles
import ServiceIndividualStyle from '@/styles/pages/ServiceIndividualStyle';

const SingleService = ({ pageData }) => {
	//! States
	const [secObj, setSecObj] = useState();

	//! Handle Active Section Animation
	const Anim = useCallback(
		(x) => {
			if (JSON.stringify(x) !== JSON.stringify(secObj)) {
				setSecObj(x);
			}
		},
		[secObj]
	);

	const sectionBuilder = useMemo(() => {
		return pageData?.templates?.length > 0
			? pageData.templates.map((template, key) => {
					const type = template.type;

					return (
						<div
							key={key}
							className='section-item'>
							{type == 'offer' && template?.children?.length ? (
								<TableItem
									underline
									animationDelay={0.1}
									title={template.title}
									list={template.children}
									active={secObj?.[`sec${key + 3}`]}
								/>
							) : null}

							{type == 'faq' && pageData.faqs?.length > 0 ? <Faq faqs={pageData.faqs} /> : null}

							{type == 'work_process' ? (
								template.children?.length > 0 ? (
									<WorkProcess
										title={template.title}
										data={template.children}
										active={secObj?.[`sec${key + 3}`]}
									/>
								) : null
							) : null}

							{type == 'testimonials' ? (
								pageData.testimonials?.length > 0 ? (
									<Testimonials
										full
										dark
										title={'testimo</br>nials'}
										items={pageData.testimonials}
									/>
								) : null
							) : null}

							{type == 'choose' ? (
								template.children?.length > 0 ? (
									<WhyChoose
										title={template.title}
										items={template.children}
									/>
								) : null
							) : null}

							{type == 'title_and_description' ? (
								<TableItem
									minWidth
									underline
									animationDelay={0.1}
									title={template.title}
									active={secObj?.[`sec${key + 3}`]}
									description={template.description}
								/>
							) : null}
						</div>
					);
				})
			: null;
	}, [pageData, secObj]);

	return (
		<Page>
			<ServiceIndividualStyle className={'singleServices'}>
				<HTMLContainer>
					<AnimationWrap state={Anim}>
						<PageTopSection
							isSingleService
							titleTag={'h1'}
							font={'h1'}
							innerTitle={pageData.number}
							serviceType={pageData.type}
							button
							{...pageData.hero}
						/>

						<div className='section-item'>
							<SubServices
								active={secObj?.sec2}
								{...pageData.sub_services}
							/>
						</div>

						{sectionBuilder}

						<div className={`section-item portfolioRow`}>
							<PortfolioShortList
								portfolioFull
								serviceType={pageData?.type}
								title={'featured</br> works'}
								active={pageData.templates?.length > 0 ? secObj?.[`sec${pageData.templates?.length + 3}`] : secObj?.sec3}
							/>
						</div>
					</AnimationWrap>
				</HTMLContainer>
			</ServiceIndividualStyle>
		</Page>
	);
};

export default SingleService;
